import "@progress/kendo-theme-bootstrap/dist/all.css";
import "animate.css/animate.css";
import "bootstrap/dist/css/bootstrap.css";
import "core-js/es6/array"
import "core-js/es6/string"
import * as React from "react";
import * as Modal from "react-modal";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "../../core/ErrorBoundary/ErrorBoundary";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import IUserSession from "../../types/IUserSession";
import Footer from "../Footer/Footer";
import Nav from "../Nav/Nav";
import Routes from "../Routing/Routes";
import "./App.css";
import "./toastr.css";

interface IAppState {
  userSession: IUserSession | null;
}

class App extends React.Component<ITranslationProps, IAppState> {

  constructor(props: ITranslationProps) {
    super(props);

    const rootElement = document.getElementById("root");
    if (rootElement) {
      Modal.setAppElement(rootElement);
    }

    this.state = { userSession: null };

    this.onLogin = this.onLogin.bind(this);
    this.onLogout = this.onLogout.bind(this);
  }

  public render() {
    return (
      <BrowserRouter>
        <ErrorBoundary errorMessage={this.props.t("Global.UnhandledError")}>
          <div>
            <Nav userSession={this.state.userSession} onLogout={this.onLogout} />
            <div className="body-container mt-3">
              <Routes onLogin={this.onLogin} />
            </div>
            <Footer />
          </div>
        </ErrorBoundary>
      </BrowserRouter>
    );
  }

  private onLogin(userSession: IUserSession) {
    this.setState({ userSession });
  }

  private onLogout() {
    this.setState({ userSession: null });
  }

}

export default translateComponent(App);



// WEBPACK FOOTER //
// ./src/components/App/App.tsx